import { Injectable } from '@angular/core';

import * as fromRoot from '@dav-store/reducers';
import * as RemitActions from '@dav-store/remit/remit.actions';
import { selectUserHasAccessScope } from '@dav-store/user/user.selectors';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { map, take, tap } from 'rxjs/operators';

import { ModalService } from './modal.service';

@Injectable({
  providedIn: 'root',
})
export class PendingContractsWarningService {
  contracts = [];
  toastrsWarningRunning = false;
  modalWarningRunning = false;

  constructor(
    private store$: Store<fromRoot.State>,
    private toastr: ToastrService,
    private modalService: ModalService
  ) {}

  showToastrs() {
    this.store$
      .select(selectUserHasAccessScope('CONTRACT_READ'))
      .pipe(
        take(1),
        tap((hasContractReadScope) => {
          if (hasContractReadScope) {
            if (!this.toastrsWarningRunning) {
              this.toastrsWarningRunning = true;
              this.clearToastrs();
              this.store$.dispatch(new RemitActions.GetPendingContractsAction());
              setTimeout(() => {
                this.getContracts();
                setTimeout(() => {
                  let showWarning30 = false;
                  let showWarning45 = false;

                  for (let x = 0; x < this.contracts.length; x++) {
                    if (this.contracts[x].tagCode === 'A') {
                      showWarning30 = true;
                    }
                    if (this.contracts[x].tagCode === 'B') {
                      showWarning45 = true;
                    }
                  }

                  if (showWarning30) {
                    this.toastr.warning(this.getMessage('A'), '', {
                      timeOut: 15000,
                      closeButton: true,
                      extendedTimeOut: 15000,
                    });
                  }

                  if (showWarning45) {
                    this.toastr.warning(this.getMessage('B'), '', {
                      timeOut: 0,
                      closeButton: true,
                      extendedTimeOut: 0,
                    });
                  }

                  this.toastrsWarningRunning = false;
                }, 100);
              }, 1000);
            }
          }
        })
      )
      .subscribe();
  }

  showModal() {
    if (!this.modalWarningRunning) {
      this.modalWarningRunning = true;
      setTimeout(() => {
        this.getContracts();
        setTimeout(() => {
          let showModal = false;
          for (let x = 0; x < this.contracts.length; x++) {
            if (this.contracts[x].tagCode === 'C') {
              showModal = true;
            }
          }
          if (showModal) {
            this.modalService.openPendingDaysWarningModal(this.getMessage('C'));
          }
          this.modalWarningRunning = false;
        }, 100);
      }, 1000);
    }
  }

  clearToastrs() {
    this.toastr.clear();
  }

  getMessage(type) {
    const userState = JSON.parse(localStorage.getItem('userState'));
    let message = '';
    if (userState.user.pendingDays && userState.user.pendingDays.checkPendingDays) {
      const pendingDays = userState.user.pendingDays.checkPendingDays;
      for (let x = 0; x < pendingDays.length; x++) {
        if (pendingDays[x].rangeTagCode === type) {
          message = pendingDays[x].loginMessage;
        }
      }
    }

    return message;
  }

  private getContracts() {
    const sub3 = this.store$.pipe(map((store) => store.remitState.pendingGridContracts)).subscribe((data) => {
      this.contracts = data;
    });
    sub3.unsubscribe();
  }
}
